import {Model} from "../decorators/model.decorator";
import {Column} from "../decorators/column.decorator";
import {BaseModel} from "./base.model";

@Model('discounts', ['discount'])
export class Discount extends BaseModel {
  @Column()
  id: number | undefined;
  @Column()
  title: string | undefined;
  @Column()
  percentage: number | undefined;
}
